// src/utils/labReportAlerts.js
//
// "Your lab report is ready": the notification-bell alert for a report that
// arrived on its own from the lab partner.
//
// When a Thyrocare order completes, the backend imports the finished PDF into
// the patient's health records (HealthRecordService.uploadLabPartnerReport,
// RecordSource.API) and triages it. Until now nothing told the patient: the
// report just appeared in My Documents. This derives an alert from the records
// list, like the other bell sources (see useNotifications.js): nothing is
// stored, so there is no read state. To keep it from sitting in the bell
// forever it only shows for a few days after the report arrived.

export const REPORT_ALERT_DAYS = 3;
const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * @param {object[]} records  GET /patients/{id}/health-records
 * @param {Date}     [now]
 * @returns {{id:string, title:string, body:string, at:string, triageResultId:(string|undefined)}[]} newest first
 */
export function labReportAlerts(records, now = new Date()) {
  return (Array.isArray(records) ? records : [])
    .filter(r => r?.source === 'API' && r.uploadedAt)
    .filter(r => {
      const age = now.getTime() - new Date(r.uploadedAt).getTime();
      return age >= 0 && age <= REPORT_ALERT_DAYS * DAY_MS;
    })
    .sort((a, b) => new Date(b.uploadedAt) - new Date(a.uploadedAt))
    .map(r => ({
      id: r.id,
      title: 'Your lab report is ready',
      body: r.labName ? `New report from ${r.labName}` : 'A new report was added to My Documents',
      at: r.uploadedAt,
      // The analysed result, when there is one — the bell links to it rather
      // than the document list (see utils/notificationTarget.js).
      triageResultId: r.latestTriage?.id,
    }));
}
